<template>
	<div class="userList column-me">
		<div class="card-view column-me">
			<div class="card-title">课程信息列表</div>
			<div class="row-me row-center">
				<div class="width300 demo-input-size">
					<el-input placeholder="课程名称" style="width: 100%;" v-model="keyword" :prefix-icon="Search"></el-input>
				</div>
				<el-form-item label="课程分类"  class="margin-left30 margin-top20 width500">
					<div class="block">
						<el-cascader
							class="width300"
							:options="classTableData"
							:props="{ checkStrictly: true , emitPath:false }"
							clearable 
							v-model="classSelected"
						></el-cascader>
					</div>
				</el-form-item>
				<el-button class="margin-left20" type="primary" size="default " @click="clickSearch">搜索</el-button>
				<el-button size="default " @click="clickClear" >重置</el-button>
				<el-button type="danger" size="default " @click="dataInfoAdd(0)" >新增</el-button>
			</div>
			<div class="column-me flex1 overflow-auto">
				<div class="flex1 overflow-auto">
					<el-table :data="tableData" border v-loading="loading" stripe="true" size="medium" style="width: 100%" height="100%">
						<el-table-column prop="title" label="课程名称" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="mold" label="课程类型" align="center" show-overflow-tooltip>
							<template #default="scope">
								<el-tag v-if="scope.row.mold == 0" effect="dark" type="info">未知</el-tag>
								<el-tag v-if="scope.row.mold == 1" effect="dark" type="danger">主科</el-tag>
								<el-tag v-if="scope.row.mold == 2" effect="dark">副科</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="TcSpecialSubInfo.name" label="课程分类" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column label="课程封面" align="center" show-overflow-tooltip>
							<template #default="scope">
								<el-image style="width: 150px; height: auto" 
									:src="scope.row.image" 
									:preview-src-list="[scope.row.image]"
									hide-on-click-modal></el-image>
							</template>
						</el-table-column>
						<el-table-column prop="virtual_human" label="虚拟人数" width="100" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="actual_human" label="实际人数" width="100" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="is_show" label="是否发布" width="100" align="center" show-overflow-tooltip>
							<template #default="scope">
								<el-switch v-model ="scope.row.is_show" :active-value="1" :inactive-value="2" @change="updateExaminaStatue(scope.row.id)"></el-switch>
							</template>
						</el-table-column>
						<el-table-column prop="sort" label="排序" width="100" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="special_duration" label="总时长" width="120" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="add_time" label="添加时间" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column label="操作" align="center" show-overflow-tooltip fixed="right">
							<template #default="scope">
								<div class="row-me center-all">
									<el-button size="small " @click="dataInfoAdd(scope.row.id)" >修改</el-button>
									<el-button type="danger" size="small " @click="clickDel(scope.row)" >删除</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="margin-top20">
					<el-pagination @current-change="handleCurrentChange" background :current-page.sync="pageNo"
                         layout="total, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import {Plus,Search} from "@element-plus/icons";
import OSS from 'ali-oss'
export default {
  components: {Plus,Search},
  name: 'MyEditor',
  data() {
    return {
		keyword: '',
		classSelected:'',
		pageNo: 1,
		total: 0,
		loading:false,
		imgloading:false,
		tableData: [],
		classTableData:[],
		editorRef:null,
		addInfo:{
			id: '',
			title: '',
			spe_sub_id: '',
			abstract: '',
			image: '',	
			sort:0,
			virtual_human: 0,
			actual_human: 0,
			is_show:2,
			is_show_status:false
		},
		boxTitle:'',
		file:null,
		infoEditBox:false,
		infoAddBox:false,
		isVideoUpload:false,
		uploading:false,
		aliOssToken:null,
		uploadPercentage:0,
		uploadVideoAliossBtn:false,
    }
  },
  setup() {
       
	},
  // 侦听器
  watch: {},
  // 计算属性
  computed: {
    Search() {
      return Search
    }
  },
  // html加载完成之前
  created() {
    this.clickSearch();
	
  },
  // html加载完成后执行。
  mounted() {
	//console.log(config.url);
	
  },
  // 事件方法执行
  methods: {	  
    clickSearch() {
      this.pageNo = 1
      this.getData();
	  this.getClassifyData();
    },
    clickClear() {
      this.keyword = ''
      this.classSelected = ''
      this.clickSearch()
    },
	//试卷信息详情页跳转
	dataInfoAdd(obj=''){
		this.$router.push({
			name:'specialAdd',
			query:{
				id:obj
			}
		})
	},
	//课程发布状态修改
	updateExaminaStatue(id){
		//examinaInfoSta
		this.$post('/admin/specialInfoSta', {
			id:id,		
		}).then((res) => {
			if (res) {
				this.$message.success('修改成功');
			}
		}).catch((error) => {
			console.log(error)
		})
	},
	//列表分页
	handleCurrentChange(pageNo) {
	    this.pageNo = pageNo
	    this.getData()
	},
	//删除
	clickDel(item) {
		this.$confirm("您确定删除吗？删除后无法恢复！", "温馨提示", {
		    confirmButtonText: "确定",
		    cancelButtonText: "取消",
		    type: "warning",
		}).then(() => {
		    this.$post('/admin/specialDel', {
		        id: item.id
		    }).then((res) => {
		        if (res) {
		            this.$message.success('删除成功')
		            this.getData()
		        }
		    }).catch((error) => {
		        console.log(error)
		    })
		}).catch((error) => {
				console.log(error)
		});	
	},
    //素材table获取数据
    getData() {
		this.loading = true;
		this.$post('/admin/specialList', {
			keyword: this.keyword,
			spe_sub_id: this.classSelected,
			page: this.pageNo
		}).then((res) => {
			if (res) {
				this.total = res.data.all_info_num
				this.tableData = res.data.listInfo
				this.loading = false;
			}
		}).catch((error) => {
			console.log(error)
		})
    },
	//素材分类数据获取
	getClassifyData(){
		this.$post('/admin/specialSubList').then((res) => {
			if (res) {
				this.classTableData = res.data;
			}
		}).catch((error) => {
			console.log(error)
		})
	}
  },
}
</script>

<style lang="scss" scoped>
.userList {
	height: 100%;
	.img-header {
		width: 60px;
		height: 60px;
		border-radius: 50%;
	}
}
</style>
